import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import GoogleAnalytics from 'react-ga';

import Playlist from './Playlist';
import Lyrics from './Lyrics';

import PlayerService from '../services/player.js'
import Element from '../services/Element.js'
import User from '../services/User.js';
import MobileIdentifier from '../services/MobileIdentifier.js';
import Train from '../services/train.js';

import '../../css/Player.css';


class Player extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      playlist: [],
      loaded: false,
      status: undefined,
      showLyrics: false,
      showVideo: false,
      showPlaylist: false,
      repeat: false,
      showShareUrl: false,
      loved: false,
      discovered: false
    }
  }

  statusChanged() {
    let change = {loaded: true};
    if (MobileIdentifier() && !this.state.loaded) {
      change['showVideo'] = true;
    }
    if (!this.state.loaded || this.state.showVideo !== change.showVideo) {
      this.setState(change);
    }
  }

  trackLoaded(track) {

    let userId = User.getId();

    if (this.state.showShareUrl) {
      this.setState({showShareUrl: false});
    }

    if (userId) {

      Train.fetchUserArtist({user: userId, artist: track.artist})
      .then((userData) => {
        this.setState({discovered: userData.discovered});
      })
      .catch((error) => {
        this.setState({discovered: false});
      });

      Train.fetchUserTrack({user: userId, artist: track.artist, track: track.track})
      .then((userData) => {
        this.setState({loved: userData.loved});
      })
      .catch((error) => {
        this.setState({loved: false});
      });

    }

 }

  componentDidMount() {
    PlayerService.load({onStatusChangeCb: this.statusChanged.bind(this), onTrackLoadedCb: this.trackLoaded.bind(this)});
  }

  componentWillReceiveProps() {
    this.setState({showLyrics: false, showVideo: false, showPlaylist: false});
  }

  playOrPause() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'togglePlay',
      label: `${PlayerService.activePlayer.paused}`
    });
    PlayerService.playOrPause();
  }

  previous() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'previousTrack'
    });
    PlayerService.previousTrack();
  }

  next() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'nextTrack'
    });
    PlayerService.nextTrack();
  }

  toggleLyrics() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'toggleVideo',
      label: `${!this.state.showLyrics}`
    });
    let state = {showLyrics: !this.state.showLyrics};
    if (state.showLyrics && this.state.showVideo)
      state.showPlaylist = false;
    this.setState(state)
  }

  toggleVideo() {

    if (PlayerService.currentTrack) {
      GoogleAnalytics.event({
        category: 'Player',
        action: 'toggleVideo',
        label: `${!this.state.showVideo}`
      });
      let state = {showVideo: !this.state.showVideo};
      if (state.showVideo && this.state.showPlaylist && this.state.showLyrics)
        state.showLyrics = false;
      this.setState(state);
    }

  }

  togglePlaylist() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'togglePlaylist',
      label: `${!this.state.showPlaylist}`
    });
    let state = {showPlaylist: !this.state.showPlaylist};
    if (state.showPlaylist && this.state.showVideo)
      state.showLyrics = false;
    this.setState(state)
  }

  discoverArtist() {
    let track = PlayerService.currentTrack;
    GoogleAnalytics.event({
      category: 'Player',
      action: 'discover',
      label: track.artist
    });
    this.setState({
      discovered: true
    });
    PlayerService.discoverArtist();
  }

  loveTrack() {
    let track = PlayerService.currentTrack;
    GoogleAnalytics.event({
      category: 'Player',
      action: 'love',
      label: `${track.artist} - ${track.track}`
    });
    this.setState({
      loved: true
    });
    PlayerService.loveTrack();
  }

  active(field) {
    if (field)
      return 'active';
    else 
      return '';
  }

  isActive() {
    return PlayerService.isActive;
  }

  shuffle() {
    GoogleAnalytics.event({
      category: 'Player',
      action: 'shufflePlaylist',
    });
    PlayerService.shuffle();
    this.setState({});
  }

  toggleRepeat() {
    let track = PlayerService.currentTrack;
    GoogleAnalytics.event({
      category: 'Player',
      action: 'repeatTrack',
      label: `${track.artist} - ${track.track}`
    });
    PlayerService.toggleRepeat();
    this.setState({repeat: PlayerService.repeat});
  }

  toggleShareUrl(evt) {
    let track = PlayerService.currentTrack;
    GoogleAnalytics.event({
      category: 'Player',
      action: 'shareUrl',
      label: `${track.artist} - ${track.track}`
    });

    if (navigator.share) {
      navigator.share({
        title: track.originalTitle,
        url: track.shareUrl
      }).then(() => {
      })
      .catch((error) => {
      });
    } else {
      this.setState({showShareUrl: !this.state.showShareUrl}, () => {
        if (this.state.showShareUrl) {
          document.getElementById('shareUrl').select();
        }
      });
    }

  }

  openShareUrl(evt) {
    window.open(PlayerService.currentTrack.shareUrl,'_blank');
  }

  minimize() {
    this.setState({showLyrics: false, showVideo: false, showPlaylist: false});
  }

  renderPlayerbar() {

    let playIcon = () => {
      if (PlayerService.paused())
        return 'icon-play';
      else
        return 'icon-pause';
    };


    let currentTrack = PlayerService.currentTrack || {};

    let isVideo = PlayerService.isVideo && this.isActive();

    let isLoggedIn = User.isLoggedIn();

    let trackArtStyle = {'backgroundImage': `url(${currentTrack.img || 'img/disabled_cd_icon.svg'})`};

    let isMobile = MobileIdentifier();

    let playerBarClasses = () => {
      return this.isActive() ? 'active' : 'disabled'
    };

    let loved = this.state.loved;
    let discovered = this.state.discovered;

    let lovedClass = loved ? 'loved active' : '';
    let discoveredClass = discovered ? 'discovered active' : '';

    return (

      <div id="playerBar" className={playerBarClasses()}>

        <span className="trackArt" onClick={this.toggleVideo.bind(this)}>
          <div className="img clickable"  style={trackArtStyle}/>
        </span>

        <div className="stats">
          <span className="artistName">
            <Link to={Element.url('artist', currentTrack)}>
              {currentTrack.artist}
            </Link>
            { isLoggedIn && currentTrack.artist && <i title="Discover artist" onClick={this.discoverArtist.bind(this)} className={`fontastic icon-new clickable ${discoveredClass}`}></i> }
          </span>
          <span className="trackName">
            <Link to={Element.url('track', currentTrack)}>
              {currentTrack.track}
            </Link> 
            { isLoggedIn && currentTrack.track && <i title="Love track" onClick={this.loveTrack.bind(this)} className={`fontastic icon-heart clickable ${lovedClass}`}></i> }
            </span>
        </div>

        <div className="commands">

          <div className="primary">
            <i onClick={this.previous.bind(this)} className="fontastic icon-previous clickable"></i>
            <i onClick={this.playOrPause.bind(this)} className={`fontastic  ${playIcon()} clickable`}></i>
            <i onClick={this.next.bind(this)} className="fontastic icon-next clickable"></i>
          </div>

          <div className="secondary">
            { !isMobile && isVideo && <i title="Show video" onClick={this.toggleVideo.bind(this)} className={`fontastic icon-eye videoIndicator clickable ${this.active(this.state.showVideo)}`}></i>}
            { !isMobile && <i title="Show playlist" onClick={this.isActive() && this.togglePlaylist.bind(this)} className={`fontastic icon-playlist clickable ${this.active(this.state.showPlaylist)}`}></i>}
            { !isMobile && <i title="Show lyrics" onClick={this.isActive() && this.toggleLyrics.bind(this)} className={`fontastic icon-lyrics clickable ${this.active(this.state.showLyrics)}`}></i>}
            { !isMobile && <i title="Repeat track" onClick={this.isActive() && this.toggleRepeat.bind(this)} className={`fontastic icon-double-reload clickable ${this.active(this.state.repeat)}`}></i>}
            <i title="Share URL" onClick={this.isActive() && this.toggleShareUrl.bind(this)} className={`fontastic icon-share clickable ${this.active(this.state.showShareUrl)}`}></i>
            { !isMobile && <i title="Shuffle playlist" onClick={this.isActive() && this.shuffle.bind(this)} className={`fontastic icon-shuffle clickable`}></i>}

            { this.state.showShareUrl && (<input id="shareUrl" readOnly onClick={this.openShareUrl.bind(this)} className="shareUrl" value={currentTrack.shareUrl}></input>) }

          </div>          
          
        </div>

      </div>

    );

  }


  render() {

    let fullPlayer = (this.state.showLyrics || this.state.showVideo || this.state.showPlaylist);
  

    let playerClasses = () => {

      let classes = [];

      if (fullPlayer) {
        classes.push('full');
      }

      if (this.state.showLyrics) {
        classes.push('lyrics');
      }

      if (this.state.showPlaylist) {
        classes.push('playlist');
      }

      return classes.join(' ');

    };

    let videoPlayerClasses = () => {

      let classes = [];
      
      if (this.state.showVideo)
        classes.push('show');

      if (this.state.showLyrics || this.state.showPlaylist)
        classes.push('half');

      return classes.join(' ');

    };

    return (

      <div id="player" className={ playerClasses() }>

        <a className="closeButton" onClick={this.minimize.bind(this)}> 
          <i className="fontastic icon-close clickable"></i>
        </a> 

        <div id="videoPlayer" className={ videoPlayerClasses() }>
          <div id="youtubePlayer"></div>
        </div>

       <Playlist hidden={!this.state.showPlaylist}/>
       <Lyrics hidden={!this.state.showLyrics}/>

        { this.renderPlayerbar() }
          
      </div>
    );
  }
}

export default Player;



// WEBPACK FOOTER //
// ./src/js/components/Player.jsx